import { usePreviousValue } from "PFCore/hooks/use_previous_value";
import { Activity, Match, Shortlist } from "PFTypes";
import React, { useRef } from "react";
import { Transition } from "react-transition-group";

import { MatchCardProvider } from "./match_card_context";
import { AnimatedMatchCard } from "./parts/animated_match_card";

type MatchCardProps = {
  match: Match;
  role: Activity;
  shortlists: Shortlist[] | null;
  isCompressed?: boolean;
};

export const MatchCard = ({ isCompressed, match, ...cardProps }: MatchCardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const wasCompressed = usePreviousValue(isCompressed);

  return (
    <Transition nodeRef={ref} in={isCompressed} timeout={300}>
      {(state) => (
        <MatchCardProvider
          {...match}
          isCompressed={
            state === "exiting" || state === "entering" ? wasCompressed || undefined : isCompressed
          }
          {...cardProps}
        >
          <AnimatedMatchCard ref={ref} state={state} />
        </MatchCardProvider>
      )}
    </Transition>
  );
};
